import React from 'react';
import { GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { GenericListItemContent } from './GenericListItemContent/GenericListItemContent';
import { _algoliaService } from '../../../core/services/algolia.service';

export const GLOBAL_SEARCH_PRODUCT_ROUTES_KEY = 'productRoutes';
const GLOBAL_SEARCH_PRODUCT_ROUTES_DEFAULT_SEARCH_TERM = 'create';

export const GlobalSearchProductRoutesRegistry: GlobalSearchRegistryItem = {
  key: GLOBAL_SEARCH_PRODUCT_ROUTES_KEY,
  title: 'Quick Actions',
  maxItemsWhenNoFiltersApplied: 4,
  sortOrder: 7,
  filters: [
    {
      value: GLOBAL_SEARCH_PRODUCT_ROUTES_KEY,
      label: 'Quick Actions'
    }
  ],
  inMemoryFiltering: false,
  dataResolver: (filters) => _algoliaService.queryProductRoutes(
      filters.search || GLOBAL_SEARCH_PRODUCT_ROUTES_DEFAULT_SEARCH_TERM
    )
      .then(res => {
        const productRoutes = res.map((item) => ({
          data: item,
          key: item.id,
          icon: item.icon,
          name: item.title,
          exitURL: item.url,
          searchKeywords: []
        }));
        return [...productRoutes];
      }),
  renderItem: (item) => (
    <GenericListItemContent primaryText={item.name} suffixIcon={item.icon} />
  )
};
